import Styles from './components.module.scss';
import CountUp from 'react-countup';

interface BigNumberCardProps {
	icon: React.ReactNode;
	label: string;
	value: number;
	color?: string;
}

export default function BigNumberCard({ icon, label, value, color }: BigNumberCardProps) {
	return (
		<div className={Styles.bigNumberCard}>
			<span>
				{icon}
				{label}
			</span>
			<CountUp style={{ color: color, fontWeight: 700, fontSize: '16px' }} start={0} end={Number(value)} decimals={2} decimal="," prefix="R$ " duration={2.5} />
		</div>
	);
}
